module.exports = __webpack_public_path__ + "static/Group 466-96b69dca3a4da86ee975a413b36a07d8.png";